"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var TextBlock_styles_1 = require("../Base/TextBlock.styles");

var TextBlock_1 = __importDefault(require("../Base/TextBlock"));

exports.HeaderTextBlockWrapper = styled_components_1.default(TextBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  ", " {\n    margin-top: 16px;\n    ", "\n  }\n\n  &.is-small {\n    ", " {\n      ", "\n    }\n  }\n\n  &.is-medium {\n    ", " {\n      ", "\n    }\n  }\n\n  &.is-large {\n    ", " {\n      ", "\n    }\n\n    ", " {\n      margin-top: 24px;\n    }\n  }\n\n  &.is-responsive {\n    ", " {\n      ", "\n\n      @media (min-width: ", "px) {\n        ", "\n      }\n\n      @media (min-width: ", "px) {\n        ", "\n      }\n    }\n\n    ", " {\n      @media (min-width: ", "px) {\n        margin-top: 24px;\n      }\n    }\n  }\n"], ["\n  text-align: center;\n  ", " {\n    margin-top: 16px;\n    ", "\n  }\n\n  &.is-small {\n    ", " {\n      ", "\n    }\n  }\n\n  &.is-medium {\n    ", " {\n      ", "\n    }\n  }\n\n  &.is-large {\n    ", " {\n      ", "\n    }\n\n    ", " {\n      margin-top: 24px;\n    }\n  }\n\n  &.is-responsive {\n    ", " {\n      ", "\n\n      @media (min-width: ", "px) {\n        ", "\n      }\n\n      @media (min-width: ", "px) {\n        ", "\n      }\n    }\n\n    ", " {\n      @media (min-width: ", "px) {\n        margin-top: 24px;\n      }\n    }\n  }\n"])), TextBlock_styles_1.BaseDescription, function (props) {
  return props.theme.font.body.v300;
}, TextBlock_styles_1.BaseTitle, function (props) {
  return props.theme.font.heading.v300;
}, TextBlock_styles_1.BaseTitle, function (props) {
  return props.theme.font.heading.v400;
}, TextBlock_styles_1.BaseTitle, function (props) {
  return props.theme.font.display.v100;
}, TextBlock_styles_1.BaseDescription, TextBlock_styles_1.BaseTitle, function (props) {
  return props.theme.font.heading.v300;
}, function (props) {
  return props.theme.breakpoint.sm;
}, function (props) {
  return props.theme.font.heading.v400;
}, function (props) {
  return props.theme.breakpoint.lg;
}, function (props) {
  return props.theme.font.display.v100;
}, TextBlock_styles_1.BaseDescription, function (props) {
  return props.theme.breakpoint.lg;
});
exports.Halo = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 30px;\n  height: 4px;\n  top: 44px;\n\n  /* Color / Yellow - Medium */\n  background: ", ";\n\n  /* Inside Auto Layout */\n  flex: none;\n  order: 0;\n  margin: 0 auto;\n  margin-bottom: 16px;\n"], ["\n  width: 30px;\n  height: 4px;\n  top: 44px;\n\n  /* Color / Yellow - Medium */\n  background: ", ";\n\n  /* Inside Auto Layout */\n  flex: none;\n  order: 0;\n  margin: 0 auto;\n  margin-bottom: 16px;\n"])), function (props) {
  return props.theme.color.secondary.v200;
});
var templateObject_1, templateObject_2;